import { render, staticRenderFns } from "./BudgetGroupsIndex.vue?vue&type=template&id=351ff462&scoped=true"
import script from "./BudgetGroupsIndex.vue?vue&type=script&lang=js"
export * from "./BudgetGroupsIndex.vue?vue&type=script&lang=js"
import style0 from "./BudgetGroupsIndex.vue?vue&type=style&index=0&id=351ff462&prod&lang=scss&scoped=true"
import style1 from "./BudgetGroupsIndex.vue?vue&type=style&index=1&id=351ff462&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351ff462",
  null
  
)

export default component.exports